import { useContext } from 'react'

import { userContext } from '../context/UserContext'

export const VIEW_ONLY_MESSAGE = 'View only access: you cannot make changes in this organisation'

// Cosmetic only; the server (RequireWriteAccess) is the authority. Unknown state is treated as writable.
const useIsViewOnly = (): boolean => {
	const { userData } = useContext(userContext)
	return userData?.access?.user.permissions.write === false
}

export default useIsViewOnly
